import React from 'react'

import { GrFacebookOption } from "react-icons/gr";
import { FaTwitter } from "react-icons/fa";
import { BsInstagram } from "react-icons/bs";
import image1 from '../../../assets/image/image_arpita1.jpg';

const Section7 = () => {
    const teamMembers = [
        
        {
            name: 'Ruhi Bulava',
            role: 'Designer',
            img: 'https://images.pexels.com/photos/2970109/pexels-photo-2970109.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load',
        },
        {
            name: 'Arpita Savani',
            role: 'Helper',
            img: image1, 
        },
        {
            name: 'Jane Doe',
            role: 'Developer',
            img:  'https://images.pexels.com/photos/3616933/pexels-photo-3616933.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load',
        },
        {
            name: 'Asmara smith',
            role: 'Tester',
            img: 'https://images.pexels.com/photos/3284696/pexels-photo-3284696.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load',
        },
    ];
    return (
        <div className='py-14 mb-24'>
            <div className='text-center '>
                <p className='text-2xl font-semibold'>Creative Team</p>
                <p>Cardigan helvetica sriracha, portland celiac truffaut woke</p>
            </div>
            <div className='flex justify-evenly flex-wrap mt-0 md:mt-14'>
               
                {teamMembers.map((member, index) => (
                    <div key={index} className='h-96 w-full md:w-72 mt-24 md:mt-22 lg:mt-0 mx-3'>
                        <img src={member.img} alt='' style={{ borderRadius: '50px 50px 0px 0px', borderBottom: '10px solid #FAC213' }} className='h-full w-full '/>
                        <p>{member.name}</p>
                        <p>{member.role}</p>
                        <p className='flex '>
                            <span className=' border-black border-2 rounded-full m-2 p-1 text-sm'>
                                <GrFacebookOption />
                            </span>
                            <span className=' border-black border-2 rounded-full m-2 p-1 text-sm'>
                                <FaTwitter />
                            </span>
                            <span className=' border-black border-2 rounded-full m-2 p-1 text-sm'>
                                <BsInstagram />
                            </span>
                        </p>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Section7
